import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Trash2, AlertTriangle } from "lucide-react";

export const DeleteUserDialog = ({ 
  open, 
  onOpenChange, 
  user, 
  onDelete, 
  deleting 
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0A0A0A] border-white/10 text-white">
        <DialogHeader>
          <DialogTitle className="font-['Unbounded'] text-red-400 flex items-center gap-2">
            <AlertTriangle className="w-5 h-5" />
            Delete User
          </DialogTitle>
          <DialogDescription className="text-[#94A3B8]">
            This action cannot be undone. This will permanently delete the user and all associated data.
          </DialogDescription>
        </DialogHeader>
        
        {user && (
          <div className="p-4 bg-red-500/10 border border-red-500/30 rounded-lg my-4">
            <p className="text-white font-medium">{user.name}</p>
            <p className="text-sm text-[#94A3B8]">{user.email}</p>
            {user.profile?.worker_code && (
              <p className="text-sm text-red-400 font-mono mt-1">{user.profile.worker_code}</p>
            )}
          </div>
        )}

        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="border-white/20 text-[#94A3B8]"
          >
            Cancel
          </Button>
          <Button
            onClick={onDelete}
            disabled={deleting}
            className="bg-red-500 text-white hover:bg-red-600"
          >
            {deleting ? (
              <span className="flex items-center gap-2">
                <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                Deleting...
              </span>
            ) : (
              <>
                <Trash2 className="w-4 h-4 mr-2" />
                Delete User
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
